import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './SearchBar.m.sass'
import Icon from 'components/Icon'
import TeamMembersViewModel from '../TeamMembersViewModel'
import Button from 'components/Button'
import Tooltip from 'components/Tooltip'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamMembersViewModel
}

export default observer(function TeamListHeader({ vm }: Props) {
  const searchFieldRef = React.useRef<HTMLInputElement>(null)
  const onSearchBarClick = React.useCallback(
    () => searchFieldRef.current && searchFieldRef.current.focus(),
    [],
  )

  return (
    <div className={cx(styles.root)}>
      <div className={styles.searchBar} onClick={onSearchBarClick}>
        <div className={styles.searchIcon}>
          <Icon name="search" />
        </div>
        <input
          ref={searchFieldRef}
          type="text"
          placeholder="Search Members"
          className={cx(styles.searchField, !vm.searchText && styles.empty)}
          value={vm.searchText}
          onChange={(e) => vm.setSearchText(e.target.value)}
        />
      </div>
      <div className={styles.filterContainer}>
        {vm.canManageTeamMember && (
          <Tooltip content="Invite New Member">
            <Button
              onClick={() => vm.showInviteModal()}
              type="text"
              className={styles.icon}
            >
              <Icon name="add" />
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  )
})
